// extracted by mini-css-extract-plugin
export default {"wrapper":"first_wrapper__SHcoW","text":"first_text__zSZV7"};